{
  "common": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "close": "Fermer",
    "submit": "Soumettre",
    "search": "Rechercher",
    "loading": "Chargement...",
    "yes": "Oui",
    "no": "Non",
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "confirm": "Confirmer",
    "done": "Terminé",
    "remove": "Retirer",
    "add": "Ajouter",
    "view": "Voir",
    "create": "Créer",
    "update": "Mettre à jour",
    "ok": "OK",
    "none": "Aucun",
    "na": "N/A",
    "prepare": "Préparer",
    "approve": "Approuver",
    "uploadFiles": "Télécharger des fichiers",
    "learnMore": "En savoir plus",
    "user": "utilisateur",
    "users": "utilisateurs"
  },
  "nav": {
    "users": "Utilisateurs",
    "groups": "Groupes",
    "developerApiTokens": "Jetons API développeur",
    "permissions": "Permissions",
    "betaFeatures": "Fonctionnalités bêta",
    "security": "Sécurité",
    "adminSettings": "Paramètres d'administration"
  },
  "pages": {
    "unauthorized": {
      "title": "Non autorisé",
      "heading": "Nous sommes désolés !",
      "message": "Il semble que vous n'ayez pas accès à cette page.",
      "contactSupport": "Si vous pensez qu'il s'agit d'une erreur, veuillez contacter le service client."
    },
    "errorBoundary": {
      "message": "Quelque chose s'est mal passé !"
    },
    "passwords": {
      "title": "Page des mots de passe",
      "description": "Lorsque cette option est activée, tous les membres de votre organisation sont obligés de changer périodiquement leur mot de passe."
    },
    "singleSignOn": {
      "title": "Page d'authentification unique"
    },
    "logo": {
      "title": "Télécharger le logo",
      "description": "Téléchargez le logo de votre organisation ici et il sera affiché dans les documents exportés."
    }
  },
  "users": {
    "searchPlaceholder": "Rechercher des utilisateurs...",
    "filterByGroup": "Filtrer par groupe",
    "inviteUser": "Inviter un utilisateur",
    "setRole": "Définir le rôle",
    "addToGroup": "Ajouter au groupe",
    "addToGroupCount": "Ajouter {{count}} {{pluralized}} au groupe",
    "removeFromGroup": "Retirer du groupe",
    "removeFromGroupCount": "Retirer {{count}} {{pluralized}} du groupe",
    "manageGroups": "Manage groups",
    "manageGroupsCount": "Manage groups for {{count}} {{pluralized}}",
    "editUser": "Modifier l'utilisateur",
    "removeUser": "Retirer l'utilisateur",
    "cancelInvitation": "Annuler l'invitation",
    "resendInvitation": "Renvoyer l'invitation",
    "usageMessage": "Vous utilisez {{activeUsersCount}} sur {{activeUsersLimit}} utilisateurs actifs et {{totalUsersCount}} sur {{totalUsersLimit}} utilisateurs totaux disponibles sur votre plan actuel. Besoin de plus ?",
    "upgradeSubscription": "Mettre à niveau votre abonnement",
    "addMoreSeats": "Ajouter des licences",
    "table": {
      "fullName": "Nom complet",
      "email": "E-mail",
      "role": "Rôle",
      "jobTitle": "Intitulé du poste",
      "department": "Service",
      "location": "Site",
      "groups": "Groupes",
      "access": "Accès"
    },
    "inviteStatus": {
      "pending": "en attente",
      "declined": "refusé",
      "accepted": "accepté"
    },
    "editUsersUsage": "Utilisateurs d'édition (Normal + Qualité) : {{activeUsersCount}} sur {{activeUsersLimit}}",
    "basicUsersUsage": "Utilisateurs basiques : {{basicUsersCount}} sur {{basicUsersLimit}}",
    "basicUsersUsageUnlimited": "Utilisateurs basiques : {{basicUsersCount}} (Illimité)"
  },
  "reassignEntities": {
    "cancel": "Annuler",
    "makeReassignments": "Effectuer des réaffectations",
    "previous": "Précédent",
    "next": "Suivant",
    "removeUser": "Retirer l'utilisateur",
    "confirm": "Confirmer",
    "save": "Enregistrer",
    "allSelected": "Tous les {{count}} sélectionnés:",
    "reviewInfo": "Consultez les informations ci-dessous",
    "addUserToGroup": "Ajouter l'utilisateur au groupe",
    "warningMessage": "Si vous procédez au retrait, les utilisateurs suivants seront ajoutés aux groupes suivants requis pour accéder aux documents avec des balises privées:",
    "userAddedToGroups": "{{userName}} sera ajouté aux groupes:",
    "steps": {
      "owner": "Documents",
      "changeRequestOwner": "Demandes de modification",
      "approver": "Actions d'approbation",
      "reviewer": "Actions de révision",
      "issues": "Problèmes",
      "events": "Événements",
      "tasks": "Tâches",
      "summary": "Confirmer les modifications et retirer l'utilisateur",
      "summaryRefactor": "Confirmer la suppression de l'utilisateur",
      "default_owner": "Assigné d'événement par défaut",
      "eventTemplateOwner": "Modèles d'événements",
      "control": "Contrôles",
      "documentTemplateOwner": "Modèles de documents"
    },
    "columns": {
      "id": "ID",
      "title": "Titre",
      "newOwner": "Nouveau propriétaire",
      "status": "Statut",
      "tags": "Balises",
      "name": "Nom",
      "prefix": "Préfixe"
    },
    "summary": {
      "documents": "Documents:",
      "documentTemplates": "Modèles de documents:",
      "changeRequests": "Demandes de modification:",
      "controls": "Contrôles:",
      "eventTemplates": "Modèles d'événements:",
      "approvalActions": "Actions d'approbation:",
      "reviewActions": "Actions de révision:",
      "issueActions": "Actions de problèmes:",
      "eventActions": "Actions d'événements:",
      "issueCollaboratorNote": "Si un nouveau propriétaire est déjà collaborateur d'un événement, il sera retiré de ses collaborateurs.",
      "taskActions": "Actions de tâches:",
      "ownershipTransfer": "La propriété de {{count}} {{type}} sera transférée à {{name}}",
      "ownershipTransferPlural": "La propriété de {{count}} {{type}}s sera transférée à {{name}}",
      "actionTransfer": "{{count}} action {{type}} sera transférée à {{name}}",
      "actionTransferPlural": "{{count}} actions {{type}} seront transférées à {{name}}",
      "eventTemplateTransfer": "{{ownershipType}} de {{count}} modèle d'événement sera transféré à {{name}}",
      "eventTemplateTransferPlural": "{{ownershipType}} de {{count}} modèles d'événements seront transférés à {{name}}"
    }
  },
  "groups": {
    "subtitle": "Créez et gérez des groupes d'utilisateurs pour organiser votre équipe et contrôler l'accès",
    "createNewGroup": "Créer un nouveau groupe",
    "assignManagers": "Assigner des gestionnaires",
    "editGroup": "Modifier le groupe",
    "deleteGroup": "Supprimer le groupe",
    "confirmDeleteTitle": "Confirmer la suppression du groupe",
    "confirmDeleteMessage": "Êtes-vous sûr de vouloir supprimer le groupe \"{{groupName}}\" ? La suppression d'un groupe faisant partie d'un plan de formation Qualio peut avoir un impact sur vos affectations de formation. Veuillez vérifier la matrice de formation pour identifier les plans concernés.",
    "yesDeleteGroup": "Oui, supprimer le groupe",
    "searchPlaceholder": "Rechercher des groupes ou des gestionnaires...",
    "table": {
      "groupName": "Nom du groupe",
      "groupManagers": "Gestionnaires du groupe",
      "includeInReports": "Inclure dans les rapports de formation"
    },
    "noManagers": "--"
  },
  "groupForm": {
    "groupName": "Nom du groupe",
    "includeInReports": "Inclure dans les rapports",
    "minLengthError": "Longueur minimale de 1 caractère requise.",
    "duplicateError": "Un groupe avec le nom \"{{groupName}}\" existe déjà."
  },
  "roles": {
    "basic": "Basique",
    "normal": "Normal",
    "quality": "Qualité"
  },
  "features": {
    "qualityEvents": {
      "name": "Événements qualité",
      "description": "Un \"Événement Qualité\" est un événement qui nécessite une action ou une réponse prédéfinie et un suivi conformément aux exigences réglementaires. Les utilisateurs qualité peuvent créer un événement, attribuer la propriété et valider les étapes/actions associées.",
      "enable": "Activer les événements qualité",
      "permissions": {
        "manageWorkflow": "Gérer le flux de travail",
        "manageAttributes": "Gérer les attributs",
        "workOnIssue": "Travailler sur le problème",
        "createIssue": "Créer un problème",
        "view": "Voir les événements",
        "create": "Créer un événement",
        "workOnExisting": "Travailler sur un événement existant",
        "manageTemplates": "Créer et gérer les modèles d'événements"
      }
    },
    "migrations": {
      "name": "Migrations",
      "description": "Le gestionnaire de migrations vous permet de télécharger facilement des documents dans Qualio lors de votre intégration.",
      "enable": "Activer les migrations",
      "permissions": {
        "create": "Créer",
        "view": "Voir",
        "prepare": "Préparer",
        "approve": "Approuver",
        "uploadFiles": "Télécharger des fichiers"
      }
    },
    "suppliers": {
      "name": "Fournisseurs",
      "description": "La fonctionnalité Fournisseurs permet à votre équipe de configurer votre politique fournisseurs, de gérer votre liste de fournisseurs approuvés et de stocker les documents d'audit des fournisseurs.",
      "access": "Accéder aux Fournisseurs"
    },
    "designControls": {
      "name": "Contrôles de conception",
      "description": "La fonctionnalité Contrôles de conception permet une gestion et une documentation efficaces du processus de conception et de développement de votre produit, garantissant la conformité et la qualité.",
      "access": "Accéder aux Contrôles de conception"
    },
    "compliance": {
      "name": "Conformité",
      "description": "La fonctionnalité Conformité permet à votre équipe de gérer les cadres, de suivre l'état des exigences et de démontrer l'adhésion aux normes de qualité et réglementaires.",
      "access": "Accéder à la Conformité"
    },
    "apiCapabilities": {
      "name": "Capacités API",
      "description": "Les Capacités API permettent l'accès aux interfaces programmables pour une intégration et une automatisation transparentes de vos systèmes d'entreprise avec les documents et la formation Qualio.",
      "access": "Accéder aux Capacités API",
      "deprecatedNote": "Ceci n'active que l'accès à l'API héritée. Veuillez utiliser les \"Jetons API développeur\" pour accorder l'accès à la nouvelle API."
    },
    "events": {
      "name": "Événements",
      "description": "La fonctionnalité Événements permet à votre équipe de créer et de gérer tous les événements qualité de la cause racine à la vérification de l'efficacité."
    },
    "notAvailable": "Cette fonctionnalité n'est pas disponible avec votre licence actuelle. Veuillez contacter votre représentant du service client pour mettre à niveau et activer les événements qualité.",
    "disableConfirmation": "Les données existantes seront sauvegardées et rendues disponibles lorsque les fonctionnalités seront réactivées. Cependant, toutes les permissions utilisateur qui ont été modifiées seront supprimées et réinitialisées à leur accès par défaut lorsque la fonctionnalité sera réactivée. Êtes-vous sûr de vouloir désactiver ?",
    "disableTitle": "Désactiver {{name}}",
    "yesDisable": "Oui, désactiver {{name}}",
    "enable": "Activer la fonctionnalité",
    "disable": "Désactiver {{name}}",
    "role": "Rôle",
    "access": "Accès",
    "none": "Aucun",
    "upgradeMessage": "Cette fonctionnalité n'est pas disponible avec votre licence actuelle. Veuillez contacter votre représentant Customer Success pour mettre à niveau et activer les événements qualité."
  },
  "status": {
    "draft": "Brouillon",
    "forReview": "En révision",
    "forApproval": "Pour approbation",
    "approved": "Approuvé",
    "approvalDeclined": "Approbation refusée",
    "effective": "En vigueur"
  },
  "forms": {
    "fullName": "Nom complet",
    "email": "Adresse e-mail",
    "role": "Rôle utilisateur",
    "adminAccess": "Accès administrateur",
    "billingAccess": "Accès à la facturation",
    "learnMoreRoles": "En savoir plus sur les rôles utilisateur.",
    "labels": {
      "fullName": "Nom complet",
      "emailAddress": "Adresse e-mail",
      "userRole": "Rôle de l'utilisateur",
      "jobTitle": "Intitulé du poste",
      "department": "Service",
      "location": "Site",
      "adminAccess": "Accès administrateur",
      "billingAccess": "Accès facturation",
      "name": "Nom",
      "role": "Rôle",
      "groups": "Groupes"
    },
    "placeholders": {
      "whatIsThisTokenFor": "À quoi sert ce jeton ?",
      "filterByNameEmailGroup": "Filtrer par nom, e-mail ou nom de groupe..."
    },
    "helperText": {
      "adminAccess": "Accorder l'accès administrateur permettra aux utilisateurs d'ajouter/supprimer des utilisateurs et des groupes, et de modifier les permissions",
      "adminAccessExtended": "Accorder l'accès administrateur permettra aux utilisateurs d'ajouter/supprimer des utilisateurs, d'ajouter/supprimer des groupes, et de gérer les permissions pour les événements et les fournisseurs",
      "inviteUser": "Un message d'invitation sera envoyé à l'adresse e-mail fournie. Il contiendra un lien de confirmation qui permet au propriétaire de l'adresse e-mail de rejoindre votre organisation.",
      "learnMoreRoles": "En savoir plus sur les rôles d'utilisateur.",
      "learnMorePermissions": "En savoir plus sur les permissions."
    },
    "permissions": {
      "viewEvents": "Voir les événements",
      "createEvents": "Créer un événement",
      "editEvents": "Travailler sur un événement existant",
      "manageEvents": "Créer et gérer les modèles d'événements",
      "accessSuppliers": "Accéder aux fournisseurs",
      "accessDesignControls": "Accéder aux contrôles de conception",
      "accessCompliance": "Accéder à la conformité"
    }
  },
  "apiCapabilities": {
    "header": "Capacités API",
    "description": "Les capacités API permettent l'accès à des interfaces programmables pour une intégration et une automatisation transparentes de vos systèmes d'entreprise avec les documents et la formation Qualio.",
    "deprecatedDescription": "Cela permet l'accès à l'API héritée uniquement. Veuillez utiliser \"Jetons API développeur\" pour accorder l'accès à la nouvelle API.",
    "errorFetchKeys": "Impossible de déterminer si l'entreprise possède des clés API en raison d'une erreur serveur.",
    "access": "Accéder aux capacités API"
  },
  "modals": {
    "inviteUser": {
      "title": "Inviter un utilisateur",
      "sendInvitation": "Envoyer l'invitation",
      "resendInvitation": "Renvoyer l'invitation",
      "reinviteMessage": "{{email}} était précédemment un membre actif de ce compte. Les réinviter restaurera leur profil avec les activités précédemment complétées."
    },
    "setRole": {
      "title": "Définir le rôle pour les utilisateurs sélectionnés"
    },
    "addToGroup": {
      "title": "Ajouter les utilisateurs sélectionnés au groupe"
    },
    "manageGroups": {
      "title": "Manage groups for selected users",
      "save": "Save",
      "saving": "Saving...",
      "searchPlaceholder": "Filter by group name..."
    },
    "removeFromGroup": {
      "title": "Retirer les utilisateurs sélectionnés du groupe",
      "visibilityWarning": "Retirer les utilisateurs sélectionnés de ce groupe masquera certains documents ou modèles à leurs propriétaires. Voulez-vous vraiment continuer ?",
      "confirmTitle": "Cette action affecte la visibilité du contenu"
    },
    "removeUser": {
      "title": "Retirer l'utilisateur",
      "confirmMessage": "Êtes-vous sûr de vouloir retirer l'utilisateur \"{{name}}\" ?"
    },
    "cancelInvite": {
      "title": "Annuler l'invitation",
      "confirmMessage": "Êtes-vous sûr de vouloir annuler l'invitation de cet utilisateur ?",
      "yesCancelUser": "Oui, annuler l'utilisateur"
    },
    "assignManagers": {
      "title": "Assigner des gestionnaires",
      "searchPlaceholder": "Filtrer par nom, e-mail ou nom de groupe...",
      "assigning": "Attribution...",
      "save": "Enregistrer"
    },
    "editUser": {
      "title": "Modifier l'utilisateur"
    },
    "editGroup": {
      "title": "Modifier le groupe"
    }
  },
  "editUser": {
    "title": "Modifier l'utilisateur",
    "header": "Modifier l'utilisateur",
    "general": "Général",
    "permissions": "Permissions",
    "defaultPermissions": "Permissions par défaut",
    "events": "Événements",
    "suppliers": "Fournisseurs",
    "designControls": "Contrôles de conception",
    "compliance": "Conformité",
    "eventsDescription": "La fonctionnalité Événements permet à votre équipe de créer et gérer tous les événements qualité depuis l'analyse de cause racine jusqu'à la vérification de l'efficacité",
    "suppliersDescription": "La fonctionnalité Fournisseurs permet à votre équipe de configurer votre politique fournisseurs, gérer votre Liste de fournisseurs approuvés et stocker les documents d'audit fournisseurs",
    "designControlsDescription": "La fonctionnalité Contrôles de conception permet une gestion et une documentation efficaces du processus de conception et développement de votre produit, garantissant conformité et qualité.",
    "complianceDescription": "La fonctionnalité Conformité permet à votre équipe de gérer les cadres réglementaires, suivre le statut des exigences et démontrer l'adhésion aux normes qualité et réglementaires.",
    "eventsWarning": "Voir les événements doit être sélectionné pour activer les permissions supplémentaires",
    "viewEventsWarning": "Voir les événements doit être sélectionné pour activer des permissions supplémentaires",
    "resetPermissions": "Réinitialiser aux permissions par défaut",
    "resetToDefault": "Réinitialiser aux permissions par défaut",
    "saveChanges": "Enregistrer les modifications",
    "eventsPermissions": "Permissions des événements",
    "defaultPermissionsTable": {
      "role": "Rôle",
      "defaultPermissions": "Permissions par défaut"
    },
    "validation": {
      "invalidFullName": "Nom complet invalide",
      "invalidEmail": "Adresse e-mail invalide"
    }
  },
  "messages": {
    "success": {
      "saved": "Enregistré avec succès",
      "deleted": "Supprimé avec succès",
      "submitted": "Soumis pour révision",
      "invitationSent": "Invitation envoyée !",
      "invitationResent": "L'invitation a été envoyée à nouveau !",
      "invitationCanceled": "Invitation de l'utilisateur annulée avec succès.",
      "userRemoved": "Utilisateur retiré avec succès.",
      "userDeleted": "Utilisateur supprimé avec succès !",
      "userUpdated": "Utilisateur mis à jour avec succès !",
      "groupCreated": "Groupe créé avec succès !",
      "groupDeleted": "Groupe supprimé avec succès !",
      "groupUpdated": "Groupe mis à jour avec succès !",
      "roleChanged": "Rôle changé avec succès pour {{count}} utilisateur(s) !",
      "usersAdded": "{{count}} utilisateur(s) ajouté(s) avec succès au groupe choisi",
      "usersRemoved": "{{count}} utilisateur(s) retiré(s) avec succès du groupe choisi",
      "groupsUpdated": "Successfully updated group membership!",
      "managersAssigned": "Gestionnaires assignés avec succès",
      "permissionsUpdated": "Permissions de l'instance mises à jour avec succès",
      "tokenCreated": "Nouveau jeton créé",
      "tokenDeleted": "Jeton API développeur supprimé avec succès",
      "tokenUpdated": "Jeton API développeur mis à jour avec succès"
    },
    "error": {
      "generic": "Une erreur s'est produite. Veuillez réessayer.",
      "notFound": "Élément non trouvé",
      "unauthorized": "Vous n'êtes pas autorisé à effectuer cette action",
      "sendInvitation": "Quelque chose s'est mal passé ! Impossible d'envoyer l'invitation.",
      "resendInvitation": "Quelque chose s'est mal passé ! Impossible de renvoyer l'invitation.",
      "cancelInvitation": "Quelque chose s'est mal passé ! Impossible d'annuler l'invitation de l'utilisateur.",
      "removeUser": "Quelque chose s'est mal passé ! Impossible de retirer l'utilisateur.",
      "updateUser": "Quelque chose s'est mal passé ! Impossible de mettre à jour l'utilisateur.",
      "extractOwnedItems": "Quelque chose s'est mal passé ! Impossible d'extraire les éléments possédés pour cet utilisateur.",
      "createGroup": "Quelque chose s'est mal passé ! Impossible de créer le groupe.",
      "deleteGroup": "Quelque chose s'est mal passé ! Impossible de supprimer le groupe.",
      "updateGroup": "Quelque chose s'est mal passé ! Impossible de mettre à jour le groupe.",
      "updateRole": "Quelque chose s'est mal passé ! Impossible de mettre à jour le rôle.",
      "setUsersToGroup": "Impossible d'affecter les utilisateurs au groupe sélectionné",
      "removeUsersFromGroup": "Impossible de retirer le(s) utilisateur(s) du groupe sélectionné",
      "manageGroups": "Unable to update group membership. Please try again.",
      "assignManagers": "Échec de l'attribution des gestionnaires",
      "updateMfa": "Impossible de mettre à jour le statut MFA pour cette entreprise",
      "updatePermissions": "Échec de la mise à jour des permissions de l'instance",
      "loadSettings": "Échec du chargement des paramètres.",
      "fetchFeatures": "Échec de la récupération des fonctionnalités",
      "updateFeatures": "Échec de la mise à jour des fonctionnalités",
      "createToken": "Impossible de créer la CLÉ API demandée en raison d'une erreur serveur",
      "tokenNameExists": "Une clé API portant ce nom existe déjà. Veuillez choisir un autre nom.",
      "deleteToken": "Impossible de supprimer la CLÉ API demandée en raison d'une erreur serveur",
      "rotateToken": "Impossible de faire tourner la CLÉ API demandée en raison d'une erreur serveur",
      "showApiKeys": "Impossible d'afficher les clés API en raison d'une erreur serveur",
      "reassignEntities": "Échec de la réaffectation des entités. Veuillez réessayer.",
      "updateToken": "Impossible de mettre à jour le jeton API demandé en raison d'une erreur serveur"
    },
    "validation": {
      "required": "Ce champ est obligatoire",
      "invalidEmail": "Adresse e-mail invalide.",
      "minLength": "Doit contenir au moins {{min}} caractères",
      "maxLength": "Ne doit pas dépasser {{max}} caractères",
      "invalidTokenName": "Nom de jeton invalide",
      "minimumAdmins": "Cette opération entraînerait zéro administrateur pour l'entreprise. Le minimum d'administrateurs requis pour chaque entreprise est de 1.",
      "minimumQuality": "L'entreprise nécessite au moins un utilisateur Qualité.",
      "documentsHidden": "Cette action entraînerait le masquage d'un ou plusieurs documents à leurs propriétaires.",
      "templatesHidden": "Cette action entraînerait le masquage d'un ou plusieurs modèles à leurs propriétaires.",
      "userAlreadyExists": "L'utilisateur enregistré avec l'e-mail {{email}} est déjà membre de cette entreprise.",
      "totalUsersLimit": "Limite d'utilisateurs totaux atteinte.",
      "activeUsersLimit": "Limite d'utilisateurs actifs atteinte.",
      "userExistsInQualio": "Un utilisateur existe déjà dans Qualio avec cette adresse e-mail."
    }
  },
  "emptyStates": {
    "noResults": "Aucun résultat trouvé",
    "noData": "Il n'y a pas de données à afficher.",
    "noBetaFeatures": {
      "title": "Aucune fonctionnalité bêta active disponible",
      "subtitle": "Veuillez revenir plus tard. Nous travaillons toujours à améliorer l'expérience Qualio."
    },
    "noApiTokens": {
      "title": "Aucun jeton API créé",
      "subtitle": "Besoin d'un jeton API pour des scripts ou des tests ? Générez un jeton API pour un accès rapide à l'API Qualio.",
      "viewPortal": "Voir le portail développeur",
      "createToken": "Créer un jeton"
    },
    "noApiAccess": {
      "title": "Vous n'avez pas accès à l'API développeur",
      "subtitle": "Contactez notre équipe de support pour accéder à l'API développeur dans Qualio.",
      "contactSupport": "Contacter le support Qualio"
    }
  },
  "security": {
    "description": "Gérez les exigences d'authentification et les paramètres de sécurité pour tous les utilisateurs de votre organisation.",
    "mfa": {
      "label": "Authentification multi-facteurs",
      "description": "Exiger de tous les utilisateurs de votre organisation qu'ils fournissent un code de vérification en plus de leur mot de passe lors de la connexion, améliorant ainsi la sécurité globale.",
      "enable": "Activer l'authentification multi-facteurs",
      "disableTitle": "Désactiver l'authentification multi-facteurs",
      "disableMessage": "Êtes-vous sûr de vouloir désactiver ce paramètre ? Les utilisateurs ne seront pas tenus de se connecter en utilisant l'authentification multi-facteurs une fois désactivée."
    }
  },
  "permissions": {
    "instancePermissions": "Permissions de l'instance",
    "aiEditing": {
      "label": "Édition assistée par IA",
      "description": "Évaluations de formation suggérées, contrôles de changement et améliorations de documents alimentés par l'IA.",
      "enable": "Activer l'édition assistée par IA"
    },
    "mcp": {
      "label": "Accès MCP",
      "description": "Autoriser les assistants et agents IA à se connecter à cette instance via le serveur MCP de Qualio.",
      "enable": "Activer l'accès MCP"
    },
    "copilot": {
      "label": "Qualio Copilot",
      "description": "Activer l'assistant IA Qualio Copilot pour cette instance.",
      "enable": "Activer Copilot"
    },
    "reviewers": {
      "label": "Réviseurs",
      "description": "Accorder aux utilisateurs Basiques la permission d'être ajoutés comme réviseur sur les documents.",
      "enable": "Tous les utilisateurs basiques peuvent être réviseurs"
    },
    "supportAccess": {
      "label": "Accès au support Qualio",
      "description": "Autoriser le support Qualio à accéder à votre instance en mode lecture seule.",
      "enable": "Activer l'accès au support"
    },
    "saveChanges": "Enregistrer les modifications",
    "termsOfService": {
      "prefix": "Les autorisations signalées par",
      "tos": "activent des fonctionnalités alimentées par l'IA. En les activant, vous acceptez d'être lié par les Conditions de service de Qualio.",
      "fairUsage": "Pour garantir une expérience cohérente pour tous les utilisateurs, nous pouvons introduire des limites d'utilisation pendant les périodes de forte demande."
    }
  },
  "betaFeatures": {
    "description": "Explorez et testez les dernières fonctionnalités que nous développons en les activant dans votre instance. Vos commentaires nous aident à affiner et perfectionner ces innovations, alors faites-nous savoir ce que vous en pensez. Lors de l'activation d'une fonctionnalité bêta, cela peut prendre quelques minutes pour que le changement prenne effet. Si vous ne voyez pas les changements, essayez de rafraîchir votre navigateur. En savoir plus sur ces fonctionnalités sur notre",
    "helpCenter": "Centre d'aide.",
    "packageNotice": "L'accès aux fonctionnalités bêta après leur disponibilité générale peut dépendre de votre offre. Contactez votre CSM pour en savoir plus.",
    "enabled": "{{name}} activé",
    "disabled": "{{name}} désactivé",
    "enable": "Activer {{name}}",
    "termsOfService": {
      "prefix": "En cliquant sur un bouton pour activer l'une des fonctionnalités bêta suivantes, vous acceptez d'être lié par les",
      "terms": "Conditions d'utilisation de Qualio,",
      "middle": "où les fonctionnalités bêta que vous activez feront partie des \"Fonctionnalités bêta\" aux fins des",
      "suffix": "Conditions d'utilisation."
    }
  },
  "devApi": {
    "backToTokens": "Retour aux jetons API",
    "createToken": "Créer un jeton",
    "tokenRoleHelper": "Quel rôle souhaitez-vous que ce jeton ait les privilèges ?",
    "adminAccessHelper": "Accorder à ce jeton la possibilité d'ajouter/supprimer des utilisateurs, d'ajouter/supprimer des groupes et de gérer les permissions pour les événements et les fournisseurs.",
    "tokenGroupsHelper": "Ajoutez éventuellement ce jeton aux groupes pour lui permettre de voir les documents privés, les événements, etc., comme un utilisateur.",
    "editToken": "Modifier le jeton"
  },
  "developerApi": {
    "description": "Les jetons API sont des clés uniques et sécurisées qui permettent un accès authentifié à l'API Qualio. Ils permettent une intégration transparente avec des systèmes externes pour automatiser les flux de travail, synchroniser les données et améliorer le suivi de la conformité.",
    "manageDescription": "Ici, vous pouvez gérer vos jetons API. Vous pouvez les créer, les supprimer et les faire tourner. La rotation d'un jeton générera une nouvelle clé de jeton et invalidera l'ancienne. Le nom et les permissions ne seront pas modifiés.",
    "expirationNote": "Chaque jeton expirera après un an, s'il n'est pas tourné. Toute action effectuée à l'aide de la clé sera enregistrée dans la piste d'audit avec le nom que vous choisissez pour le jeton.",
    "docsAlert": "Vous intégrez l'API Qualio ? Retrouvez des guides et la référence complète de l'API dans notre portail développeur.",
    "viewApiDocs": "Voir la documentation de l'API",
    "createToken": "Créer un jeton",
    "backToTokens": "Retour aux jetons API",
    "createTokenHeader": "Créer un jeton",
    "tokenName": "Nom",
    "tokenRole": "Rôle",
    "tokenRoleHelper": "Quel rôle souhaitez-vous que ce jeton ait les privilèges ?",
    "tokenGroups": "Groupes",
    "tokenGroupsHelper": "Ajoutez éventuellement ce jeton aux groupes pour lui permettre de voir les documents privés, les événements, etc., comme un utilisateur.",
    "adminAccessHelper": "Accorder à ce jeton la possibilité d'ajouter/supprimer des utilisateurs, d'ajouter/supprimer des groupes et de gérer les permissions pour les événements et les fournisseurs.",
    "tokenCreatedTitle": "Nouveau jeton créé",
    "storeSecurelyTitle": "Stockez ce jeton en toute sécurité",
    "storeSecurelyMessage": "C'est la seule fois où vous pourrez voir le jeton complet.",
    "apiTokenLabel": "Jeton API",
    "copyToken": "Copier le jeton",
    "tokenLostWarning": "Si le jeton est perdu, vous devrez en générer un nouveau. La régénération d'un nouveau jeton invalidera l'ancien jeton, mais il aura les mêmes permissions et le même nom.",
    "deleteToken": "Supprimer le jeton API développeur",
    "confirmDeleteTitle": "Confirmer la suppression du jeton",
    "confirmDeleteMessage": "Êtes-vous sûr de vouloir supprimer le jeton « {{tokenName}} » ? Toute intégration utilisant ce jeton perdra immédiatement l'accès à l'API Qualio.",
    "confirmRotateTitle": "Confirmer la rotation du jeton",
    "confirmRotateMessage": "Êtes-vous sûr de vouloir effectuer la rotation du jeton « {{tokenName}} » ? Cela génère une nouvelle clé de jeton et invalide immédiatement la clé actuelle ; toute intégration qui l'utilise perdra l'accès jusqu'à sa mise à jour.",
    "table": {
      "name": "Nom",
      "created": "Créé",
      "expires": "Expire",
      "type": "Type",
      "personal": "Personnel",
      "system": "Système",
      "personalTooltip": "Ce token est lié à un utilisateur réel et hérite de ses accès. Il cessera de fonctionner si cet utilisateur est désactivé.",
      "systemTooltip": "Ce token n'est pas lié à un utilisateur réel et possède ses propres autorisations.",
      "rotate": "Faire tourner",
      "delete": "Supprimer"
    }
  },
  "reassign": {
    "removeUserTitle": "Retirer l'utilisateur : {{name}}",
    "removeUserTitleGeneric": "Retirer l'utilisateur",
    "description": "Avant de retirer un utilisateur, vous devez transférer la propriété des documents et des problèmes, tâches et actions en cours à d'autres utilisateurs.",
    "descriptionEvents": "Avant de retirer un utilisateur, vous devez transférer la propriété des documents et des événements, tâches et actions en cours à d'autres utilisateurs.",
    "descriptionExtended": "Avant de retirer un utilisateur, vous devez transférer la propriété des documents, modèles, problèmes, tâches et actions en cours à d'autres utilisateurs.",
    "descriptionExtendedEvents": "Avant de retirer un utilisateur, vous devez transférer la propriété des documents, modèles, événements, tâches et actions en cours à d'autres utilisateurs.",
    "steps": {
      "documents": "Documents",
      "changeRequests": "Demandes de modification",
      "approvalActions": "Actions d'approbation",
      "reviewActions": "Actions de révision",
      "issues": "Problèmes",
      "tasks": "Tâches",
      "confirmChanges": "Confirmer les modifications et retirer l'utilisateur",
      "defaultEventAssignee": "Assigné par défaut de l'événement",
      "eventTemplates": "Modèles d'événements",
      "controls": "Contrôles",
      "documentTemplates": "Modèles de documents"
    },
    "bulkSelect": {
      "allSelected": "Tous les {{size}} sélectionnés :",
      "save": "Enregistrer"
    },
    "table": {
      "id": "ID",
      "title": "Titre",
      "newOwner": "Nouveau propriétaire",
      "status": "Statut",
      "tags": "Étiquettes",
      "name": "Nom",
      "prefix": "Préfixe"
    },
    "summary": {
      "reviewInfo": "Examinez les informations ci-dessous",
      "addUserToGroupTitle": "Ajouter l'utilisateur au groupe",
      "addUserToGroupMessage": "Si vous procédez à la suppression, les utilisateurs suivants seront ajoutés aux groupes suivants requis pour accéder aux documents avec des étiquettes privées :",
      "userAddedToGroups": "{{userName}} sera ajouté aux groupes : {{groupNames}}"
    }
  },
  "aria": {
    "userlistCheckbox": "case à cocher liste d'utilisateurs",
    "addToGroup": "Ajouter au groupe",
    "removeFromGroup": "Retirer du groupe",
    "manageGroups": "Manage groups",
    "adminAccess": "accès administrateur",
    "billingAccess": "accès facturation",
    "email": "e-mail",
    "fullName": "nom complet",
    "role": "rôle",
    "group": "groupe",
    "groupName": "nom du groupe",
    "includeInReports": "inclure dans les rapports",
    "inviteUserForm": "formulaire d'invitation d'utilisateur",
    "groupForm": "formulaire de groupe",
    "nextButton": "bouton suivant",
    "canViewQualityEvents": "peut voir les événements qualité",
    "canCreateQualityEvents": "peut créer des événements qualité",
    "canEditQualityEvents": "peut modifier les événements qualité",
    "canManageQualityEvents": "peut gérer les événements qualité"
  }
}
